module.exports = __webpack_public_path__ + "img/loads.4660ba1d.svg";